import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { permissionActions } from "../../store/permission-store/permission-slice";
import { uiActions } from "../../store/ui-slice";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect } from "react";
import { getTokenInfo } from "../../utils/Guard";

let restartPage = false;

const PermissionForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permission = (state)=>state.permission.permission;
  const isValid = useSelector((state) => state.permission.permissionValidation);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);

  const onChangeHandler = (id, value) => {
    dispatch(permissionActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(permissionActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(permissionActions.setFieldValid({ id, value: false }));
    }
  };
  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      permission.id > 0 &&
      restartPage
    ) {
      dispatch(permissionActions.restartState());
      window.location.href = "/permissions";
    }
  }, [permission.id, dispatch, navigate, notification]);

  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (permission.name === "") {
      dispatch(permissionActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } 
    else if (permission.code === "") {
      dispatch(permissionActions.setFieldValid({ id: "code", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (permission.description === "") {
      dispatch(permissionActions.setFieldValid({ id: "description", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else {
      dispatch(props.actionpermission(permission, userInfo.Email));
      restartPage = true;
    }
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Permiso:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {permission && permission.name && permission.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={permission.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Código:
              </label>
              <InputText
                id="code"
                value={permission.code}
                onChange={(e) => onChangeHandler("code", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("code")}</div>
            </div>
            <div className="field col-12 md:col-8">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={permission.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("description")}</div>
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/permissions");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default PermissionForms;
